<template>
  <div class="white py-4 px-4">
    <v-layout
      align-center
    >
      <div
        v-if="!hideTitle"
        class="title subTitle mr-4"
      >
        空運行事曆
      </div>
      <b class="title">{{ viewMonth | dateFormat('YYYY') }}年</b>
      <v-btn
        icon
        class="ma-0"
        @click="prevMonth"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <b class="title">{{ viewMonth | dateFormat('MM') }}月</b>
      <v-btn
        icon
        class="ma-0"
        @click="nextMonth"
      >
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>

      <v-spacer />
      <div
        v-if="post"
        class="caption white--text px-3 py-1"
        style="cursor: pointer;overflow: hidden;text-overflow: ellipsis;border-radius: 20px;background: #b12a31;"
        @click="
          $store.dispatch('viewPost', post.poid)
        "
      >
        {{ post.title }}
      </div>
    </v-layout>

    <v-layout class="ma-0 py-2">
      <div style="flex: 1;">
        <v-layout
          class="text-xs-right caption ma-0"
          style="height: 30px;"
        >
          <v-flex>
            週日
          </v-flex>
          <v-flex>
            週一
          </v-flex>
          <v-flex>
            週二
          </v-flex>
          <v-flex>
            週三
          </v-flex>
          <v-flex>
            週四
          </v-flex>
          <v-flex>
            週五
          </v-flex>
          <v-flex>
            週六
          </v-flex>
        </v-layout>
        <v-layout
          wrap
          class="calendarWrap caption ma-0"
        >
          <div
            v-for="(item,i) in monthData"
            :key="i"
            :class="getItemClass(item)"
            style="width: 14.28571%"
            @click="toggleView(item)"
          >
            <div class="date mb-1">
              <b>{{ item.text }}</b>
            </div>
            <template v-if="viewDate && viewDate.schedule">
              <v-spacer />
              <div>
                <v-layout
                  v-if="sameDay(viewDate.schedule.flight, item.date)"
                  align-center
                  class="schedule ma-0"
                >
                  <v-flex class="eventName noDot ma-0 pa-0">
                    <i
                      class="iconfont iconfeiji1"
                      style="color: #22aef7;"
                    />
                  </v-flex>
                </v-layout>
                <div
                  v-if="sameDay(viewDate.date, item.date)"
                  class="catAt"
                >
                  截單
                </div>

                <div
                  v-if="sameDay(viewDate.schedule.cc, item.date)"
                  class="catAt"
                >
                  清關
                </div>
                <div
                  v-if="sameDay(viewDate.schedule.deliveryHeimao, item.date)"
                  class="catAt"
                >
                  派件
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-for="event in item.events"
                :key="event.calid"
                class="eventName"
              >
                {{ event.calEvent }}
              </div>
            </template>
          </div>
        </v-layout>
      </div>
      <div
        class="dayDetailWrap pt-3 caption px-2"
      >
        <template v-if="viewDate">
          <div>
            {{ viewDate.date | dateFormat('YYYY-MM-DD') }}
          </div>
          <div class="deatilDay mt-2">
            {{ viewDate.date | dateFormat('D') }}
          </div>
          <div
            v-if="viewDate.events"
            class="mt-2"
          >
            <div
              v-for="event in viewDate.events"
              :key="event.calid"
            >
              {{ event.calEvent }}
            </div>
          </div>
          <template v-if="viewDate && viewDate.schedule">
            <div
              style="border-top: 1px solid #eee;"
              class="mt-3"
            />
            <div class="mt-3">
              當日截單時間
            </div>
            <div class="scheduleDate mt-2">
              {{ viewDate.schedule.cut | dateFormat('HH:mm') }}
            </div>
            <!-- {{ viewDate }} -->

            <div class="mt-3">
              大陸報關時間
            </div>
            <div class="pt-1">
              {{ viewDate.schedule.export | dateFormat('MM-DD') }}
            </div>
            <div class="mt-3">
              航班時間
            </div>
            <div class="pt-1">
              {{ viewDate.schedule.flight | dateFormat('MM-DD') }}
            </div>
            <div class="mt-3">
              台灣清關時間
            </div>
            <div class="pt-1">
              {{ viewDate.schedule.cc | dateFormat('MM-DD') }}
            </div>
            <div class="mt-3">
              黑貓派件時間
            </div>
            <div>
              {{ viewDate.schedule.deliveryHeimao | dateFormat('MM-DD') }}
            </div>
            <div class="mt-3">
              新竹派件時間
            </div>
            <div>
              {{ viewDate.schedule.deliveryXinzhu | dateFormat('MM-DD') }}
            </div>
          </template>

          <div class="mt-4">
            <div
              v-if="viewDate.events"
              class="mt-2"
            >
              <div
                v-for="event in viewDate.events"
                :key="event.calid"
              >
                {{ event.calBrief }}
              </div>
            </div>
          <!-- 特殊說明：XX當日截單時間當日截單時間當日截單時間 -->
          </div>
        </template>
      </div>
    </v-layout>

    <template v-if="!inject">
      <div class="title subTitle mt-4">
        空運說明
      </div>

      <v-layout class="ma-0 textWrap mt-4">
        <v-flex class="mr-2 pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_adescription.png"
              width="23"
              class="mr-4"
            >服務說明
          </div>
          <div class="px-4 ml-4 mt-3">
            巧巧郎是以從事海快為主的集運公司，空運服務是為了彌補會員偶爾需要寄輕小件及一些海快不可以寄但空運可以寄的商品。目前空運可以寄特貨和不含肉食品，普貨特貨同價。
          </div>
        </v-flex>
        <v-flex class="pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_aprescription.png"
              width="23"
              class="mr-4"
            >運送時效說明
          </div>
          <div class="px-4 ml-4 mt-3">
            空運服務時效目前仍不穩定，空運時效跟海快時效接近，建議如非必要請不要使用空運。我們會逐漸優化空運服務，爭取追趕海快的服務品質。
          </div>
        </v-flex>
      </v-layout>

      <v-layout class="ma-0 textWrap mt-2">
        <v-flex class="mr-2 pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_amaterial.png"
              width="23"
              class="mr-4"
            >體積重量限制
          </div>
          <div class="px-4 ml-4 mt-3">
            最大體積/重量限制：<br>
            物品單邊長度不可超過160cm，
            三邊若兩邊超過 70cm 和 85cm，就會多出額外報關移倉費用(新台幣$4700起，以清關公司收費為主)
            ，重量限制<span class="black--text">70KG</span>/件以内。<br>
            <br>
            單邊超過115cm（含）的物體皆視為超長件，由於超過最大的透明袋尺寸，無法封口，當合併包裹下單時，倉庫只能將長度超過115cm的商品（無論是不是細長）單獨打包，因此會產生多個包裹。強烈建議使用巧拼，節省稅金。<br>
            <br>
            超長件下單注意事項：<br>
            1.有超長件合併包裹下單時，由於同一筆訂單會打成多個包裹，只能選擇x3申報（不包稅）<br>
            2.合併打包後的包裹如果單個集運包裹不足1KG將以1KG收費，如果超長件包裹不足1KG由於是單獨打包將以1KG收費。<br>
            <!-- 細長件合包限制：<br>
            細長件需單獨打包，或者只能跟長度90公分以上包裹合併打包，不得合併其他規格貨物（細長件判定條件比較複雜請先用能寄嗎試算）。 -->
          </div>
        </v-flex>
        <v-flex class="pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_import.png"
              width="23"
              class="mr-4"
            >進口項目
          </div>
          <div class="px-4 ml-4 mt-3">
            普貨為不帶電、不帶磁、不含液體粉末膏狀物品...等等<br>
            特貨為帶電池、帶磁、化妝品、液體、粉末、膏狀...等等
          </div>
        </v-flex>
      </v-layout>

      <v-layout class="ma-0 textWrap mt-2">
        <v-flex class="mr-2 pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_aweight.png"
              width="23"
              class="mr-4"
            >拋貨/超才費用
          </div>
          <div class="px-4 ml-4 mt-3">
            空運包裹長x寬x高/6000=體積重量<br>
            體積重量與實際重量取較大的重量計重<br>
            體積重量大於實際重量3倍以內全部優惠（即按實際重量計重）<br>
            體積重量大於實際重量3倍以上享有50%優惠（即按體積重量/2計重）
          </div>
        </v-flex>
        <v-flex class="pa-4">
          <div class="title mb-2">
            <img
              src="./images/icon_aprohibit.png"
              width="23"
              class="mr-4"
            >禁止運送項目
          </div>
          <div class="px-4 ml-4 mt-3">
            酒、毒品、槍支、水果、植物、電話卡(網卡)、易燃易爆物、電動車類(平衡車、滑板車)、電子煙相關產品...
            <br>
            建議購物前先使用本站的
            “
            <b style="color:#ff806b">能寄嗎</b>
            <img
              src="../parcel/images/nengjima.png"
              height="22"
              class="mr-2"
              style="vertical-align: middle;"
            >
            ”
            功能查詢，國際運輸有一定風險，針對易碎品務必請賣家包裝好
          </div>
        </v-flex>
      </v-layout>

      <div class="mt-2 pa-4 tiemTextWrap">
        <div class="title mb-2">
          <img
            src="./images/icon_atime.png"
            width="23"
            class="mr-4"
          >本週計劃
        </div>
        <div class="px-4 ml-4 mt-3">
          <table>
            <tr>
              <th style="background: #faf9d7;">
                星期
              </th>
              <th>截單時間</th>
              <th>大陸報關</th>
              <th>航班</th>
              <th>台灣清關</th>
              <th>黑貓派件</th>
              <th>歷時天數</th>
              <th>新竹派件</th>
              <th>歷時天數</th>
            </tr>
            <tr>
              <td style="background: #b2cbe2;">
                星期一
              </td>
              <td rowspan="6">
                14:00
              </td>
              <td rowspan="7">
                當天
              </td>
              <td>週三</td>
              <td>早班/晚班</td>
              <td>週四</td>
              <td>4天</td>
              <td>週四</td>
              <td>4天</td>
            </tr>

            <tr>
              <td style="background: #b2cbe2;">
                星期二
              </td>
              <td>週四</td>
              <td>早班/晚班</td>
              <td>週五</td>
              <td>4天</td>
              <td>週五</td>
              <td>4天</td>
            </tr>
            <tr>
              <td style="background: #bcf9d0;">
                星期三
              </td>
              <td>週五</td>
              <td>早班/晚班</td>
              <td>週六</td>
              <td>4天</td>
              <td>週一</td>
              <td>6天</td>
            </tr>
            <tr>
              <td style="background: #bcf9d0;">
                星期四
              </td>
              <td>週六</td>
              <td>早班</td>
              <td>週一</td>
              <td>5天</td>
              <td>週一</td>
              <td>5天</td>
            </tr>

            <tr>
              <td style="background: #faf9d7;">
                星期五
              </td>
              <td>週日</td>
              <td>晚班</td>
              <td>週一</td>
              <td>4天</td>
              <td>週一</td>
              <td>4天</td>
            </tr>

            <tr>
              <td style="background: #faf9d7;">
                星期六
              </td>
              <td>週一</td>
              <td>早班/晚班</td>
              <td>週二</td>
              <td>4天</td>
              <td>週二</td>
              <td>4天</td>
            </tr>

            <tr>
              <td style="background: #faf9d7;">
                星期日
              </td>
              <td>
                11:00
              </td>
              <td>週二</td>
              <td>早班/晚班</td>
              <td>週三</td>
              <td>4天</td>
              <td>週二</td>
              <td>4天</td>
            </tr>
          </table>
          <div class="mt-2">
            PS:航班落地當天清關，早班 0:00-8:00 晚班 12:00-16:00，新竹、黑貓週日不派件，大榮週末兩天不派件
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  components: {},
  props: {
    inject: Boolean,
    hideTitle: Boolean,
  },
  data () {
    return {
      viewMonth: dayjs().set('date', 1),
      eventList: [],
      MMDD: dayjs().format('YYYMMDD'),
      post: null,
    }
  },
  computed: {
    dayNum () {
      const dayNum = new Date(this.viewMonth.get('year'), this.viewMonth.get('month') + 1, 0)
      return dayNum.getDate()
    },
    monthData () {
      const days = []
      const dayFront = this.viewMonth.day()
      for (let i = dayFront; i > 0; i--) {
        const d = this.viewMonth.add(-i, 'day')
        days.push({
          date: d,
          MMDD: d.format('YYYMMDD'),
          text: d.format('DD'),
        })
      }

      for (let i = 0; i < this.dayNum; i++) {
        const d = this.viewMonth.add(i, 'day')
        days.push({
          date: d,
          MMDD: d.format('YYYMMDD'),
          text: i === 0 ? d.format('MM月DD日') : d.format('DD'),
        })
      }

      const endDate = days[days.length - 1].date

      const dayEnd = dayjs(this.viewMonth).add(1, 'month').add(-1, 'day').day()
      if (dayEnd < 6) {
        for (let i = 1; i <= 6 - dayEnd; i++) {
          const d = endDate.add(i, 'day')
          days.push({
            date: d,
            MMDD: d.format('YYYMMDD'),
            text: i === 1 ? d.format('MM月DD日') : d.format('DD'),
          })
        }
      }

      const currDate = dayjs().format('YYYY-MM-DD')
      days.forEach(dateItem => {
        dateItem.sameDay = dateItem.date.format('YYYY-MM-DD') === currDate

        // 从 eventList 获取特殊事件（停运、放假等）
        const event = this.eventList.find(item => item.date === dateItem.date.format('YYYY-MM-DD'))
        dateItem.events = event ? event.events : null

        if (dateItem.events) {
          dateItem.off = dateItem.events.find(event => event.calEvent.indexOf('停運') > -1)
          dateItem.qingguan = dateItem.events.find(event => event.calEvent.indexOf('清關') > -1)
          dateItem.haiguan = dateItem.events.find(event => event.calEvent.indexOf('海關') > -1)
          dateItem.xinzhu = dateItem.events.find(event => event.calEvent.indexOf('新竹') > -1)
          dateItem.heimao = dateItem.events.find(event => event.calEvent.indexOf('黑貓') > -1)
        }

        if (!dateItem.off) {
          // 为每一天生成航班行程安排（作为截单日）
          dateItem.schedule = this.generateAirSchedule(dateItem.date)
        }
      })

      return days
    },
    currViewDay () {
      return this.monthData.find(item => item.MMDD === this.MMDD)
    },
    viewDate () {
      // 如果用户选择了日期，显示该日期；否则显示今天
      return this.currViewDay || this.monthData.find(item => item.sameDay)
    },
  },
  watch: {
    viewMonth () {
      this.MMDD = dayjs(this.viewMonth).format('YYYMMDD')
      this.fetchList()
    },
  },
  async mounted () {
    this.fetchList()
    this.post = await this.$store.dispatch('post/fetchCalendarNotice', {
      // objTable: 'calendar',
      objid: 'air',
    })
  },
  methods: {
    // 根据截单日期生成空运行程安排
    generateAirSchedule (cutDate) {
      const weekday = cutDate.day() // 0=週日, 1=週一, ..., 6=週六
      const cutTime = weekday === 0 ? '11:00' : '14:00' // 週日11:00，其他14:00

      // 航班规则：周一→周三，周二→周四，周三→周五，周四→周六，周五→周日，周六→周一，周日→周二
      const flightDaysMap = {
        1: 2, // 週一截單 → 週三航班（+2天）
        2: 2, // 週二截單 → 週四航班（+2天）
        3: 2, // 週三截單 → 週五航班（+2天）
        4: 2, // 週四截單 → 週六航班（+2天）
        5: 2, // 週五截單 → 週日航班（+2天）
        6: 2, // 週六截單 → 週一航班（+2天）
        0: 2, // 週日截單 → 週二航班（+2天）
      }

      // 黑猫派件规则：航班后1天
      const heimaoDeliveryDaysMap = {
        1: 3, // 週一截單 → 週四派件（+3天）
        2: 3, // 週二截單 → 週五派件（+3天）
        3: 3, // 週三截單 → 週六派件（+3天）
        4: 4, // 週四截單 → 週一派件（+4天，周日不派件）
        5: 3, // 週五截單 → 週一派件（+3天）
        6: 3, // 週六截單 → 週二派件（+3天）
        0: 3, // 週日截單 → 週三派件（+3天）
      }

      // 新竹派件规则：大部分与黑猫相同，周三例外
      const xinzhuDeliveryDaysMap = {
        1: 3, // 週一截單 → 週四派件（+3天）
        2: 3, // 週二截單 → 週五派件（+3天）
        3: 5, // 週三截單 → 週一派件（+5天，周末不派件）
        4: 4, // 週四截單 → 週一派件（+4天）
        5: 3, // 週五截單 → 週一派件（+3天）
        6: 3, // 週六截單 → 週二派件（+3天）
        0: 3, // 週日截單 → 週三派件（+3天）
      }

      const flightDays = flightDaysMap[weekday]
      const heimaoDeliveryDays = heimaoDeliveryDaysMap[weekday]
      const xinzhuDeliveryDays = xinzhuDeliveryDaysMap[weekday]

      return {
        cut: dayjs(cutDate).hour(parseInt(cutTime.split(':')[0])).minute(parseInt(cutTime.split(':')[1])),
        export: cutDate, // 大陆报关：当天
        flight: cutDate.add(flightDays, 'day'), // 航班
        cc: cutDate.add(flightDays, 'day'), // 台湾清关：航班当天
        deliveryHeimao: cutDate.add(heimaoDeliveryDays, 'day'), // 黑猫派件
        deliveryXinzhu: cutDate.add(xinzhuDeliveryDays, 'day'), // 新竹派件
      }
    },
    dayBetween (startDate, endDate, date) {
      return dayjs(startDate) < dayjs(date) && dayjs(endDate) > dayjs(date)
    },
    sameDay (d1, d2) {
      return dayjs(d1).format('YYYY-MM-DD') === dayjs(d2).format('YYYY-MM-DD')
    },
    getItemClass (item) {
      const currViewDay = this.viewDate
      const p = {
        active: this.MMDD === item.MMDD,
        sameDay: !currViewDay && item.sameDay,
      }
      if (currViewDay && currViewDay.schedule) {
        return {
          ...p,
          cut: this.sameDay(currViewDay.date, item.date), // 截单日
          flight: this.sameDay(currViewDay.schedule.flight, item.date), // 航班日
          cc: this.sameDay(currViewDay.schedule.cc, item.date), // 清关日
          delivery: this.sameDay(currViewDay.schedule.deliveryHeimao, item.date), // 派件日
        }
      }
      return p
    },
    toggleView (item) {
      if (this.MMDD === item.MMDD) {
        this.MMDD = ''
      } else {
        this.MMDD = item.MMDD
      }
    },
    prevMonth () {
      this.viewMonth = dayjs(this.viewMonth).add(-1, 'month')
    },
    nextMonth () {
      this.viewMonth = dayjs(this.viewMonth).add(1, 'month')
    },
    async fetchList () {
      // 往前后多查 6 天
      const res = await this.$store.dispatch('calendar/index', {
        calType: 'air',
        // dateStart: dayjs(this.viewMonth).format('YYYY-MM-DD'),
        dateStart: dayjs(this.viewMonth).add(-6, 'day').format('YYYY-MM-DD'),
        dateEnd: dayjs(this.viewMonth).add(1, 'month').add(5, 'day').format('YYYY-MM-DD'),
      })
      if (!res.data.error) {
        this.eventList = res.data.list
      }
    },
  },
}
</script>
<style lang="postcss" scoped>
.subTitle {
  color: #22AFF7;
  &:before {
    background: currentColor;
  }
}
.calendarWrap {
  border: 2px solid #22AFF7;
  > * {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    text-align: right;
    padding: 5px;
    min-height: 90px;
    cursor: pointer;
    &.active {
      border: 2px solid #FF9800;
    }
    &.sameDay {
      border: 2px solid green;
    }
    &.hasEvent {
      background: #feeee4;
      .date {
        color: #f00;
      }
    }
    .eventName {
      text-align: left;
      &.greenEvent {
        &:before {
          background: #22AFF7;
        }
      }
      &.noDot {
        &:before {
          background: none;
          width: 0;
        }
      }
      &:before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #f00;
        border-radius: 50%;
      }
    }
    .schedule {
      flex: none;
    }
    &.cut, &.pack {
      background: #fff6e7;
    }
    &.cut {
      background: #fdeaea;
    }
    &.flight {
      background: #e6f6ff;
    }
    &.cc {
      background: #e6f6ff;
    }
    &.delivery {
      background: #ebedff;
    }
  }
}
.dayDetailWrap {
  width: 110px;
  margin-top: 30px;
  background: #22AFF7;
  color: #fff;
  text-align: center;
  .deatilDay {
    background: #FFC107;
    width: 60px;
    height: 60px;
    line-height: 60px;
    margin: auto;
    font-size: 30px;
  }
  .scheduleDate {
    .num {
      display: inline-block;
      width: 15px;
      height: 15px;
      line-height: 15px;
      background: #fff;
      color: #000;
      text-align: center;
    }
  }
}

.textWrap {
  > * {
    border: 2px solid #22AFF7;
    flex: 1;
    .title {
      color: #22AFF7;
      font-weight: bold;
      img {
        vertical-align: middle;
      }
    }
  }
}
.tiemTextWrap {
  border: 2px solid #22AFF7;
  img {
    vertical-align: middle;
  }
  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    th,td{
      border: 1px solid #22AFF7;
    }
    th {
      padding: 10px 5px;
    }
    td {
      padding: 8px 5px;
    }
  }
}
.subTitle {
  font-weight: bold;
}
</style>
